module.exports = __webpack_public_path__ + "static/img/G5_V2_cut.bc2d79a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/captation/img/G5_V2_cut.png
// module id = U8vi
// module chunks = 1